import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { trackContact } from '../utils/metaPixel';
import { getPageName, isCustomerFacingPath } from '../utils/pageNames';
import './WhatsAppFloat.css';

/** 08117027589 in international format, as wa.me requires. */
const WHATSAPP_NUMBER = '2348117027589';

const WhatsAppFloat: React.FC = () => {
  const location = useLocation();

  // Internal screens (the queue display) don't get a customer chat button.
  if (!isCustomerFacingPath(location.pathname)) return null;

  const pageName = getPageName(location.pathname);
  const message = `Hi Immersia! I'm on the ${pageName} page and I'd like to make an enquiry.`;
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Immersia on WhatsApp"
      onClick={() => trackContact(pageName)}
    >
      <span className="whatsapp-float__pulse" aria-hidden="true" />
      <FaWhatsapp className="whatsapp-float__icon" aria-hidden="true" />
      <span className="whatsapp-float__label">Chat with us</span>
    </a>
  );
};

export default WhatsAppFloat;
